(() => {
  class CachorrosPasos {
    constructor(root) {
      this.root = root;
      this.scenes = Array.from(root.querySelectorAll('[data-cp-scene]'));
      this.images = Array.from(root.querySelectorAll('[data-cp-img]'));
      this.dots = Array.from(root.querySelectorAll('[data-cp-dot]'));
      this.prevBtn = root.querySelector('[data-cp-prev]');
      this.nextBtn = root.querySelector('[data-cp-next]');
      this.currentEl = root.querySelector('[data-cp-current]');
      this.total = this.scenes.length;
      this.index = 0;
      this.timer = null;
      this.autoplay = root.dataset.autoplay === 'true';
      this.autoplayDelay = Number(root.dataset.autoplayDelay) || 6000;

      if (!this.total) return;
      this.bind();
      this.render();
    }

    bind() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.go(this.index - 1);
          this.stopAutoplay();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.go(this.index + 1);
          this.stopAutoplay();
        });
      }
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(Number(dot.dataset.sceneIndex));
          this.stopAutoplay();
        });
      });

      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.go(this.index - 1);
          this.stopAutoplay();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.go(this.index + 1);
          this.stopAutoplay();
        }
      });

      this.root.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.root.addEventListener('mouseleave', () => this.resumeAutoplay());

      let touchStartX = 0;
      this.root.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      this.root.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) this.go(this.index + 1);
          else this.go(this.index - 1);
          this.stopAutoplay();
        }
      }, { passive: true });

      if (this.autoplay) this.startAutoplay();
    }

    go(next) {
      const n = ((next % this.total) + this.total) % this.total;
      if (n === this.index) return;
      this.index = n;
      this.render();
    }

    render() {
      this.scenes.forEach((scene, i) => {
        scene.classList.toggle('is-active', i === this.index);
      });
      this.images.forEach((img, i) => {
        img.classList.toggle('is-active', i === this.index);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
      });
      if (this.currentEl) {
        this.currentEl.textContent = String(this.index + 1).padStart(2, '0');
      }
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === this.total - 1;
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = window.setInterval(() => {
        this.go(this.index + 1);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    pauseAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
        this._wasAutoplay = true;
      }
    }

    resumeAutoplay() {
      if (this._wasAutoplay && this.autoplay) {
        this._wasAutoplay = false;
        this.startAutoplay();
      }
    }
  }

  const boot = () => {
    document.querySelectorAll('[data-cachorros-pasos]').forEach((root) => {
      if (root.dataset.cpReady === 'true') return;
      root.dataset.cpReady = 'true';
      new CachorrosPasos(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
